export interface ShugoChara {
  name: string;
  description: string;
  image: string;
}

export interface AnimeCharacter {
  id: string;
  name: string;
  enName: string;
  title: string;
  faction: '守护者' | '复活社' | '守护甜心';
  gender: string;
  birthday: string;
  zodiac: string;
  cv: string;
  cvEn: string;
  quote: string;
  short: string;
  story: string[];
  image: string;
  chara: ShugoChara;
}

export const characters: AnimeCharacter[] = [
  {
    id: 'amu-hinamori',
    name: '日奈森亚梦',
    enName: 'Hinamori Amu',
    title: '圣夜学园守护者「Joker」· 本作主角',
    faction: '守护者',
    gender: '女',
    birthday: '9月24日',
    zodiac: '天秤座',
    cv: '伊藤加奈惠',
    cvEn: 'Ito Kanae',
    quote: '守护蛋，请赐予我改变自己的勇气！',
    short: '外表冷酷、内心害羞的女孩，拥有四颗守护蛋，是史上最特别、也是最强大的守护者Joker。',
    story: [
      '日奈森亚梦是圣夜学园小学部五年级学生，外表看起来酷酷的、难以接近，实际上是个害羞又容易紧张的女孩子。因为害怕自己不够酷，她一直戴着伪装自己的面具生活。某天早晨，她的床上出现了三颗会发光的蛋——守护蛋，从此她的命运彻底改变。',
      '为了守护「心灵之蛋」，亚梦加入了圣夜学园的守护者组织，成为传说中最神秘的「Joker」，拥有与其他守护者都不同的力量。她既无法被简单归入任何一个职位，却也因此能同时获得守护者的信任与孩子们的亲近。',
      '随着剧情推进，亚梦在一次次"角色变换"与"角色改造"中逐渐正视真实的自己，学会接受内心软弱的那个"爱哭鬼亚梦"。她与月咏几斗之间若即若离的情感线，以及守护甜心"方块"的觉醒，都是本作最动人的部分。',
    ],
    image: 'https://readdy.ai/api/search-image?query=soft%20pastel%20anime%20portrait%20illustration%20of%20a%20cheerful%20girl%20with%20long%20pink%20twin-tails%20tied%20with%20red%20ribbons%20and%20small%20heart%20shaped%20hairpins%2C%20wide%20amber%20eyes%2C%20school%20uniform%2C%20dreamy%20shoujo%20magical%20girl%20style%2C%20warm%20cream%20background%20with%20floating%20sakura%20petals%20and%20gentle%20sparkles%2C%20soft%20natural%20lighting%2C%20clean%20elegant%20composition%2C%20high%20detail&width=600&height=800&seq=amu-char-01&orientation=portrait',
    chara: {
      name: '小兰 / 米奇 / 苏',
      description: '运动系小兰、艺术系米奇与料理系苏，分别代表亚梦直率、敏感与温柔的三面。',
      image: 'https://readdy.ai/api/search-image?query=soft%20pastel%20anime%20illustration%20of%20three%20tiny%20cute%20chibi%20guardians%20standing%20together%2C%20one%20pink%20energetic%20girl%2C%20one%20green%20artistic%20girl%2C%20one%20yellow%20cooking%20girl%2C%20each%20with%20heart%20shaped%20emblem%20on%20chest%2C%20dreamy%20shoujo%20style%2C%20warm%20cream%20background%20with%20sparkles%2C%20clean%20composition%2C%20high%20detail&width=400&height=400&seq=amu-chara-01&orientation=squarish',
    },
  },
  {
    id: 'ikuto-tsukiyomi',
    name: '月咏几斗',
    enName: 'Tsukiyomi Ikuto',
    title: '天才小提琴少年 · 复活社成员',
    faction: '复活社',
    gender: '男',
    birthday: '12月1日',
    zodiac: '射手座',
    cv: '中村悠一',
    cvEn: 'Nakamura Yuichi',
    quote: '不管这双手是否沾染黑暗，我都要守护你。',
    short: '小提琴天才少年，表面玩世不恭，内心却背负着沉重的秘密，与复活社有着千丝万缕的联系。',
    story: [
      '月咏几斗是拥有惊人小提琴天赋的冷峻少年，因家人与复活社的纠葛，被迫卷入"心灵之蛋"的争夺。他与亚梦的命运因一场天台上的相遇而交织，成为全作最具张力的感情线。',
      '几斗表面轻佻、爱捉弄亚梦，实则一直在暗中以自己的方式保护身边的人。他不想让任何人知道自己的痛苦，独自承受着来自复活社的命令与家人的期待。',
      '他的守护甜心是以黑猫形态出现的「阿夜」。在一次次与亚梦的并肩同行中，几斗逐渐学会不再把一切都扛在自己肩上，也开始相信"软弱并不可耻"。',
    ],
    image: 'https://readdy.ai/api/search-image?query=soft%20pastel%20anime%20portrait%20illustration%20of%20a%20cool%20handsome%20teenage%20boy%20with%20messy%20dark%20indigo%20hair%20and%20sharp%20teal%20eyes%2C%20wearing%20an%20open%20white%20shirt%20with%20a%20violin%20and%20a%20small%20black%20cat%20on%20his%20shoulder%2C%20mysterious%20dreamy%20shoujo%20style%2C%20warm%20cream%20background%20with%20sakura%20petals%20and%20soft%20shadows%2C%20clean%20elegant%20composition%2C%20high%20detail&width=600&height=800&seq=ikuto-char-01&orientation=portrait',
    chara: {
      name: '阿夜（黑猫）',
      description: '以黑猫形态守护几斗的守护甜心，顽皮又黏人，常趴在几斗肩上。',
      image: 'https://readdy.ai/api/search-image?query=soft%20pastel%20anime%20illustration%20of%20a%20cute%20small%20black%20cat%20with%20big%20expressive%20eyes%20and%20a%20tiny%20red%20bell%20collar%2C%20sitting%20and%20meowing%2C%20dreamy%20shoujo%20magical%20style%2C%20warm%20cream%20background%20with%20sparkles%2C%20clean%20composition%2C%20high%20detail&width=400&height=400&seq=ikuto-chara-01&orientation=squarish',
    },
  },
  {
    id: 'tadase-hotori',
    name: '边里唯世',
    enName: 'Hotori Tadase',
    title: '圣夜学园守护者「King」',
    faction: '守护者',
    gender: '男',
    birthday: '3月29日',
    zodiac: '白羊座',
    cv: '高木礼子',
    cvEn: 'Takagi Reiko',
    quote: '我一定要成为配得上亚梦的王子殿下。',
    short: '品学兼优的守护者King，温柔又自律，是亚梦暗恋的对象，也是"白色王子大人"。',
    story: [
      '边里唯世是圣夜学园守护者组织的「King」，成绩优异、举止优雅，是校园里人人称羡的"白色王子大人"。看似完美的他，其实同样在努力摆脱"必须完美"的压力。',
      '唯世对亚梦抱有好感，却因为守护者王子的身份与"脸红即变人格"的弱点而常常陷入窘境。他的守护甜心「奇迹」骄傲又可爱，总在关键时刻点醒他。',
      '作为King，唯世始终把守护校园与守护者的责任放在首位。他的成长，是一个学会接纳不完美、并坦然面对真实情感的过程。',
    ],
    image: 'https://readdy.ai/api/search-image?query=soft%20pastel%20anime%20portrait%20illustration%20of%20a%20kind%20handsome%20boy%20with%20neat%20golden%20blond%20hair%20and%20gentle%20blue%20eyes%2C%20wearing%20an%20elegant%20white%20school%20uniform%20with%20a%20small%20crown%20emblem%2C%20holding%20a%20white%20flower%2C%20dreamy%20shoujo%20prince%20style%2C%20warm%20cream%20background%20with%20sakura%20petals%2C%20clean%20elegant%20composition%2C%20high%20detail&width=600&height=800&seq=tadase-char-01&orientation=portrait',
    chara: {
      name: '奇迹',
      description: '骄傲的王子型守护甜心，常替唯世说出心底最真实的想法。',
      image: 'https://readdy.ai/api/search-image?query=soft%20pastel%20anime%20illustration%20of%20a%20small%20proud%20chibi%20prince%20character%20with%20golden%20hair%20and%20a%20tiny%20golden%20crown%2C%20arms%20crossed%20looking%20confident%2C%20dreamy%20shoujo%20style%2C%20warm%20cream%20background%20with%20sparkles%2C%20clean%20composition%2C%20high%20detail&width=400&height=400&seq=tadase-chara-01&orientation=squarish',
    },
  },
  {
    id: 'kukai-souma',
    name: '相马空海',
    enName: 'Souma Kukai',
    title: '圣夜学园守护者「Jack」· 前足球部王牌',
    faction: '守护者',
    gender: '男',
    birthday: '8月17日',
    zodiac: '狮子座',
    cv: '阿部敦',
    cvEn: 'Abe Atsushi',
    quote: '拼尽全力，就是最好的保护。',
    short: '阳光开朗的运动系守护者Jack，曾是足球部王牌，性格直率、重情义。',
    story: [
      '相马空海是守护者中的「Jack」，个性开朗爽朗，曾经是圣夜学园足球部的王牌前锋。他嘴上常说"随便应付"的话，做起事来却意外地认真可靠。',
      '空海是守护者中最年长也最接地气的存在，总是用自己的方式照顾着学弟学妹。他与亚梦之间有着兄弟般的情谊，是少数能看穿亚梦逞强的人之一。',
      '他的守护甜心「大地」热情又可靠。在面临升学与守护者职位的抉择时，空海教会了大家"即使要分别，也要认真告别"的成长课题。',
    ],
    image: 'https://readdy.ai/api/search-image?query=soft%20pastel%20anime%20portrait%20illustration%20of%20a%20cheerful%20athletic%20teenage%20boy%20with%20short%20orange%20brown%20hair%20and%20a%20sports%20headband%2C%20wearing%20a%20blue%20soccer%20jersey%20and%20holding%20a%20soccer%20ball%2C%20bright%20smile%2C%20dreamy%20shoujo%20sporty%20style%2C%20warm%20cream%20background%20with%20sakura%20petals%2C%20clean%20elegant%20composition%2C%20high%20detail&width=600&height=800&seq=kukai-char-01&orientation=portrait',
    chara: {
      name: '大地',
      description: '热情可靠的足球型守护甜心，充满运动家精神。',
      image: 'https://readdy.ai/api/search-image?query=soft%20pastel%20anime%20illustration%20of%20a%20small%20chibi%20guardian%20boy%20with%20short%20orange%20hair%20holding%20a%20tiny%20soccer%20ball%2C%20energetic%20pose%2C%20dreamy%20shoujo%20sporty%20style%2C%20warm%20cream%20background%20with%20sparkles%2C%20clean%20composition%2C%20high%20detail&width=400&height=400&seq=kukai-chara-01&orientation=squarish',
    },
  },
  {
    id: 'yaya-yuiki',
    name: '结木弥耶',
    enName: 'Yuiki Yaya',
    title: '圣夜学园守护者「Ace」',
    faction: '守护者',
    gender: '女',
    birthday: '5月25日',
    zodiac: '双子座',
    cv: '中村知子',
    cvEn: 'Nakamura Tomoko',
    quote: '今天也要元气满满地吃甜甜圈哦！',
    short: '娇小可爱的守护者Ace，幼儿园学生，说话爱用撒娇语气，最爱甜甜圈。',
    story: [
      '结木弥耶是守护者中年龄最小的「Ace」，还是幼儿园大班的孩子。她说话总带着"~的说"的可爱尾音，最爱甜甜圈和糖果，是全场的开心果。',
      '别看她小，弥耶有着超越年龄的敏锐与直觉。她总能用自己的天真直率，点破大孩子们纠结许久的问题，是守护者里不可缺少的"治愈担当"。',
      '她的守护甜心「皮皮」同样活泼爱撒娇。在依赖与被依赖之间，弥耶也在一点点学着长大，懂得除了撒娇，更要学着去照顾和体谅别人。',
    ],
    image: 'https://readdy.ai/api/search-image?query=soft%20pastel%20anime%20portrait%20illustration%20of%20a%20tiny%20cute%20little%20girl%20with%20twin%20buns%20and%20big%20sparkling%20eyes%2C%20wearing%20a%20pastel%20baby%20pink%20dress%20with%20a%20big%20ribbon%2C%20holding%20a%20pink%20donut%2C%20adorable%20chibi%20style%2C%20dreamy%20shoujo%20style%2C%20warm%20cream%20background%20with%20sakura%20petals%20and%20sparkles%2C%20clean%20composition%2C%20high%20detail&width=600&height=800&seq=yaya-char-01&orientation=portrait',
    chara: {
      name: '皮皮',
      description: '活泼爱撒娇的小公主型守护甜心，与弥耶形影不离。',
      image: 'https://readdy.ai/api/search-image?query=soft%20pastel%20anime%20illustration%20of%20a%20tiny%20cute%20chibi%20princess%20guardian%20with%20small%20pigtails%20and%20a%20pink%20dress%20holding%20a%20lollipop%2C%20adorable%20style%2C%20dreamy%20shoujo%20style%2C%20warm%20cream%20background%20with%20sparkles%2C%20clean%20composition%2C%20high%20detail&width=400&height=400&seq=yaya-chara-01&orientation=squarish',
    },
  },
  {
    id: 'nagihiko-fujisaki',
    name: '藤咲凪彦（抚子）',
    enName: 'Fujisaki Nagihiko',
    title: '前圣夜学园守护者「Queen」',
    faction: '守护者',
    gender: '男',
    birthday: '7月4日',
    zodiac: '巨蟹座',
    cv: '千叶纱子',
    cvEn: 'Chiba Saeko',
    quote: '舞蹈能传达的温柔，比语言更多。',
    short: '擅长古典芭蕾的优雅少年，曾以"藤咲抚子"的身份担任守护者Queen，是亚梦最好的朋友之一。',
    story: [
      '藤咲凪彦是出身舞蹈世家的优雅少年，曾以女装"藤咲抚子"的身份进入圣夜学园，担任守护者「Queen」，成为亚梦最亲密的朋友。他的古典芭蕾造诣极深，一举一动都透着优雅。',
      '后来他以本名"凪彦"重回校园，向亚梦坦白了自己的身份。这段重逢让两人之间既有小尴尬，也多了几分更坦诚的默契。',
      '他的守护甜心「节奏」同样痴迷舞蹈。在守护者与舞蹈家两种身份之间，凪彦不断寻找着真正属于自己的舞台，也学会了用舞蹈去表达内心那些说不出口的温柔。',
    ],
    image: 'https://readdy.ai/api/search-image?query=soft%20pastel%20anime%20portrait%20illustration%20of%20a%20graceful%20elegant%20androgynous%20teenage%20character%20with%20long%20flowing%20teal%20hair%20and%20gentle%20eyes%2C%20wearing%20a%20flowing%20white%20ballet%20costume%2C%20poised%20ballet%20dance%20posture%2C%20dreamy%20shoujo%20artistic%20style%2C%20warm%20cream%20background%20with%20sakura%20petals%20and%20soft%20light%2C%20clean%20elegant%20composition%2C%20high%20detail&width=600&height=800&seq=nagihiko-char-01&orientation=portrait',
    chara: {
      name: '节奏',
      description: '热爱舞蹈的优雅守护甜心，动作与气质都充满艺术感。',
      image: 'https://readdy.ai/api/search-image?query=soft%20pastel%20anime%20illustration%20of%20a%20small%20elegant%20chibi%20guardian%20with%20teal%20hair%20in%20a%20ballet%20dance%20pose%2C%20artistic%20dreamy%20shoujo%20style%2C%20warm%20cream%20background%20with%20sparkles%2C%20clean%20composition%2C%20high%20detail&width=400&height=400&seq=nagihiko-chara-01&orientation=squarish',
    },
  },
  {
    id: 'rima-mashiro',
    name: '真城璃舞',
    enName: 'Mashiro Rima',
    title: '圣夜学园守护者「Queen」',
    faction: '守护者',
    gender: '女',
    birthday: '2月2日',
    zodiac: '水瓶座',
    cv: '矢作纱友里',
    cvEn: 'Yahagi Sayuri',
    quote: '我讨厌的东西，才不需要理由。',
    short: '外表毒舌冷淡的新任Queen，其实内心温柔又怕寂寞，与弥耶是最佳搭档。',
    story: [
      '真城璃舞是继抚子之后担任守护者「Queen」的女孩，外表冷淡毒舌，说话总是带刺，似乎对什么都不感兴趣。实际上，她只是害怕受伤，用冷漠保护自己柔软的内心。',
      '她与结木弥耶意外地合拍，一个毒舌一个撒娇，成为守护者里最默契的组合。在与弥耶、亚梦的相处中，璃舞逐渐卸下心防，露出了真正温柔的一面。',
      '她的守护甜心「嘻嘻」与她性格完全相反。经由一次次的角色改变与相处，璃舞学会了正视自己的真心，也明白了"偶尔坦率一点，并不会失去什么"。',
    ],
    image: 'https://readdy.ai/api/search-image?query=soft%20pastel%20anime%20portrait%20illustration%20of%20a%20cool%20elegant%20girl%20with%20long%20pink%20hair%20in%20a%20side%20ponytail%20and%20a%20slightly%20detached%20expression%2C%20wearing%20a%20neat%20school%20uniform%20with%20a%20ribbon%2C%20dreamy%20shoujo%20style%2C%20warm%20cream%20background%20with%20sakura%20petals%20and%20soft%20shadows%2C%20clean%20elegant%20composition%2C%20high%20detail&width=600&height=800&seq=rima-char-01&orientation=portrait',
    chara: {
      name: '嘻嘻',
      description: '热情开朗的守护甜心，与璃舞的性格形成有趣反差。',
      image: 'https://readdy.ai/api/search-image?query=soft%20pastel%20anime%20illustration%20of%20a%20small%20bright%20cheerful%20chibi%20guardian%20with%20big%20smile%20and%20pink%20hair%2C%20energetic%20happy%20pose%2C%20dreamy%20shoujo%20style%2C%20warm%20cream%20background%20with%20sparkles%2C%20clean%20composition%2C%20high%20detail&width=400&height=400&seq=rima-chara-01&orientation=squarish',
    },
  },
  {
    id: 'yu-nikaidou',
    name: '二阶堂悠',
    enName: 'Nikaidou Yu',
    title: '复活社研究员 · 前新宿小学教师',
    faction: '复活社',
    gender: '男',
    birthday: '4月18日',
    zodiac: '白羊座',
    cv: '间岛淳司',
    cvEn: 'Majima Junji',
    quote: '孩子的心，是最值得被温柔对待的东西。',
    short: '一心为复活社服务的"科学家"，却在与亚梦的相处中重拾了当老师的初心。',
    story: [
      '二阶堂悠原本是满怀理想的小学教师，因未能保住自己的"心灵之蛋"而一度迷失，转而投入复活社，成为一名冷静甚至有些冷酷的"科学家"，一心研究"心灵之蛋"的秘密。',
      '他以代理老师的身份接近亚梦与守护者们，却在一次次与孩子们的相处中，被那份纯粹与真诚所打动，逐渐找回了自己曾以为早已丢失的初心。',
      '他的转变是复活社线中最具人性温度的部分。最终，悠选择直面内心，也终于找回了属于自己的那颗"心灵之蛋"。',
    ],
    image: 'https://readdy.ai/api/search-image?query=soft%20pastel%20anime%20portrait%20illustration%20of%20a%20mature%20young%20man%20with%20neat%20dark%20hair%20and%20glasses%2C%20wearing%20a%20white%20lab%20coat%20over%20a%20shirt%2C%20holding%20a%20notebook%2C%20calm%20serious%20expression%2C%20dreamy%20shoujo%20style%2C%20warm%20cream%20background%20with%20sakura%20petals%2C%20clean%20elegant%20composition%2C%20high%20detail&width=600&height=800&seq=yu-char-01&orientation=portrait',
    chara: {
      name: '——',
      description: '曾失去"心灵之蛋"，在故事后期重新找回，但未具现具体的守护甜心。',
      image: 'https://readdy.ai/api/search-image?query=soft%20pastel%20anime%20illustration%20of%20a%20glowing%20golden%20egg%20with%20a%20tiny%20crack%20of%20light%2C%20symbolic%20of%20hope%20and%20new%20beginnings%2C%20dreamy%20shoujo%20style%2C%20warm%20cream%20background%20with%20sparkles%2C%20clean%20composition%2C%20high%20detail&width=400&height=400&seq=yu-chara-01&orientation=squarish',
    },
  },
  {
    id: 'utau-hoshina',
    name: '星名歌呗',
    enName: 'Hoshina Utau',
    title: '人气偶像歌手 · 月咏几斗之妹',
    faction: '复活社',
    gender: '女',
    birthday: '11月9日',
    zodiac: '天蝎座',
    cv: '水树奈奈',
    cvEn: 'Mizuki Nana',
    quote: '我唱歌，是为了守护重要的人。',
    short: '当红偶像歌手，月咏几斗的妹妹，外表高傲、歌声充满魔力，内心却渴望亲情。',
    story: [
      '星名歌呗是人气偶像歌手，也是月咏几斗同母异父的妹妹。她外表高傲华丽，歌声拥有能够影响人心的特殊力量，一度站在复活社一边。',
      '表面上，歌呗似乎只在乎自己的歌声与地位，实际上她做的一切都是为了拯救哥哥几斗。那份笨拙而强烈的亲情，是她最柔软也最动人的秘密。',
      '随着剧情展开，歌呗在一次次"角色改造"与被拯救中，逐渐放下防备，也与亚梦建立了亦敌亦友的深厚羁绊。她的成长，是"用歌声守护重要之人"的最好诠释。',
    ],
    image: 'https://readdy.ai/api/search-image?query=soft%20pastel%20anime%20portrait%20illustration%20of%20a%20glamorous%20idol%20girl%20with%20long%20golden%20blond%20twin-tails%20and%20confident%20violet%20eyes%2C%20wearing%20an%20elegant%20stage%20dress%20with%20a%20microphone%2C%20sparkling%20stage%20lights%2C%20dreamy%20shoujo%20idol%20style%2C%20warm%20cream%20background%20with%20sakura%20petals%20and%20sparkles%2C%20clean%20elegant%20composition%2C%20high%20detail&width=600&height=800&seq=utau-char-01&orientation=portrait',
    chara: {
      name: '依琉 / 绘琉',
      description: '同为偶像身份的依琉与温柔守护的绘琉，是歌呗的双重守护甜心。',
      image: 'https://readdy.ai/api/search-image?query=soft%20pastel%20anime%20illustration%20of%20two%20small%20cute%20chibi%20singer%20guardians%20holding%20a%20microphone%2C%20one%20energetic%20blond%20and%20one%20gentle%20with%20wings%2C%20dreamy%20shoujo%20idol%20style%2C%20warm%20cream%20background%20with%20sparkles%2C%20clean%20composition%2C%20high%20detail&width=400&height=400&seq=utau-chara-01&orientation=squarish',
    },
  },
  {
    id: 'yukari-sanjou',
    name: '三条由佳里',
    enName: 'Sanjou Yukari',
    title: '复活社职员',
    faction: '复活社',
    gender: '女',
    birthday: '6月12日',
    zodiac: '双子座',
    cv: '夏树里奥',
    cvEn: 'Natsuki Rio',
    quote: '每个人都该为自己的选择负责。',
    short: '复活社的核心职员之一，冷静干练，与二阶堂悠关系密切。',
    story: [
      '三条由佳里是复活社的核心职员之一，个性冷静、手段干练，负责"心灵之蛋"相关的重要任务。她与二阶堂悠同为复活社共事的伙伴，两人之间既有默契也有各自的立场与坚持。',
      '相比被欲望与执念支配的众人，由佳里始终保持着清醒的判断。她相信"每个人都该为自己的选择负责"，也因此在一次次任务中，对复活社的本质产生动摇。',
      '作为复活社阵营中少有的理性人物，由佳里的存在让"正义与立场"的边界变得更加耐人寻味。',
    ],
    image: 'https://readdy.ai/api/search-image?query=soft%20pastel%20anime%20portrait%20illustration%20of%20a%20composed%20elegant%20adult%20woman%20with%20neat%20dark%20hair%20and%20a%20professional%20look%2C%20wearing%20a%20smart%20office%20suit%20with%20a%20clipboard%2C%20calm%20confident%20expression%2C%20dreamy%20shoujo%20style%2C%20warm%20cream%20background%20with%20sakura%20petals%2C%20clean%20elegant%20composition%2C%20high%20detail&width=600&height=800&seq=yukari-char-01&orientation=portrait',
    chara: {
      name: '——',
      description: '主要作为复活社职员登场，未作为守护甜心持有者重点描写。',
      image: 'https://readdy.ai/api/search-image?query=soft%20pastel%20anime%20illustration%20of%20a%20small%20glowing%20heart%20shaped%20emblem%20floating%20above%20an%20egg%2C%20symbolic%20motif%2C%20dreamy%20shoujo%20style%2C%20warm%20cream%20background%20with%20sparkles%2C%20clean%20composition%2C%20high%20detail&width=400&height=400&seq=yukari-chara-01&orientation=squarish',
    },
  },
];

export const guardianCharas = [
  {
    id: 'ran',
    name: '小兰',
    owner: '日奈森亚梦',
    trait: '运动系',
    image: 'https://readdy.ai/api/search-image?query=soft%20pastel%20anime%20illustration%20of%20a%20tiny%20energetic%20chibi%20girl%20with%20short%20pink%20hair%2C%20cheerful%20running%20pose%2C%20heart%20emblem%20on%20chest%2C%20dreamy%20shoujo%20style%2C%20warm%20cream%20background%20with%20sparkles%2C%20clean%20composition%2C%20high%20detail&width=400&height=400&seq=ran-chibi-01&orientation=squarish',
    desc: '代表亚梦"直率活泼"一面的守护甜心，性格开朗，热爱运动，口头禅是"要做就做得漂亮！"。',
  },
  {
    id: 'miki',
    name: '米奇',
    owner: '日奈森亚梦',
    trait: '艺术系',
    image: 'https://readdy.ai/api/search-image?query=soft%20pastel%20anime%20illustration%20of%20a%20tiny%20quiet%20chibi%20girl%20with%20green%20hair%20and%20a%20paintbrush%2C%20holding%20an%20art%20palette%2C%20calm%20artistic%20pose%2C%20dreamy%20shoujo%20style%2C%20warm%20cream%20background%20with%20sparkles%2C%20clean%20composition%2C%20high%20detail&width=400&height=400&seq=miki-chibi-01&orientation=squarish',
    desc: '代表亚梦"敏感细腻"一面的守护甜心，热爱艺术与创作，个性安静而敏锐。',
  },
  {
    id: 'su',
    name: '苏',
    owner: '日奈森亚梦',
    trait: '料理系',
    image: 'https://readdy.ai/api/search-image?query=soft%20pastel%20anime%20illustration%20of%20a%20tiny%20sweet%20chibi%20girl%20with%20yellow%20hair%20wearing%20an%20apron%2C%20holding%20a%20spoon%20and%20a%20dessert%2C%20gentle%20smile%2C%20dreamy%20shoujo%20style%2C%20warm%20cream%20background%20with%20sparkles%2C%20clean%20composition%2C%20high%20detail&width=400&height=400&seq=su-chibi-01&orientation=squarish',
    desc: '代表亚梦"温柔体贴"一面的守护甜心，喜欢下厨，个性软萌又爱撒娇。',
  },
  {
    id: 'kiseki',
    name: '奇迹',
    owner: '边里唯世',
    trait: '王子型',
    image: 'https://readdy.ai/api/search-image?query=soft%20pastel%20anime%20illustration%20of%20a%20tiny%20proud%20chibi%20prince%20with%20golden%20hair%20and%20a%20small%20crown%2C%20arms%20crossed%2C%20regal%20confident%20pose%2C%20dreamy%20shoujo%20style%2C%20warm%20cream%20background%20with%20sparkles%2C%20clean%20composition%2C%20high%20detail&width=400&height=400&seq=kiseki-chibi-01&orientation=squarish',
    desc: '唯世的守护甜心，骄傲又好胜，总是一副"本王子最厉害"的样子。',
  },
  {
    id: 'daichi',
    name: '大地',
    owner: '相马空海',
    trait: '运动型',
    image: 'https://readdy.ai/api/search-image?query=soft%20pastel%20anime%20illustration%20of%20a%20small%20athletic%20chibi%20boy%20with%20orange%20hair%20and%20a%20headband%20holding%20a%20tiny%20ball%2C%20energetic%20reliable%20pose%2C%20dreamy%20shoujo%20style%2C%20warm%20cream%20background%20with%20sparkles%2C%20clean%20composition%2C%20high%20detail&width=400&height=400&seq=daichi-chibi-01&orientation=squarish',
    desc: '空海的守护甜心，热血可靠，充满运动家精神。',
  },
  {
    id: 'pepe',
    name: '皮皮',
    owner: '结木弥耶',
    trait: '公主型',
    image: 'https://readdy.ai/api/search-image?query=soft%20pastel%20anime%20illustration%20of%20a%20tiny%20cute%20chibi%20princess%20with%20small%20pigtails%20and%20a%20pink%20dress%20holding%20a%20lollipop%2C%20adorable%20playful%20pose%2C%20dreamy%20shoujo%20style%2C%20warm%20cream%20background%20with%20sparkles%2C%20clean%20composition%2C%20high%20detail&width=400&height=400&seq=pepe-chibi-01&orientation=squarish',
    desc: '弥耶的守护甜心，爱撒娇、爱甜食，与主人如出一辙。',
  },
  {
    id: 'rhythm',
    name: '节奏',
    owner: '藤咲凪彦',
    trait: '艺术型',
    image: 'https://readdy.ai/api/search-image?query=soft%20pastel%20anime%20illustration%20of%20a%20small%20elegant%20chibi%20guardian%20with%20teal%20hair%20in%20a%20graceful%20ballet%20pose%2C%20artistic%20dreamy%20shoujo%20style%2C%20warm%20cream%20background%20with%20sparkles%2C%20clean%20composition%2C%20high%20detail&width=400&height=400&seq=rhythm-chibi-01&orientation=squarish',
    desc: '凪彦的守护甜心，痴迷舞蹈，气质优雅从容。',
  },
  {
    id: 'hihi',
    name: '嘻嘻',
    owner: '真城璃舞',
    trait: '阳光型',
    image: 'https://readdy.ai/api/search-image?query=soft%20pastel%20anime%20illustration%20of%20a%20small%20bright%20cheerful%20chibi%20with%20pink%20hair%20and%20a%20huge%20happy%20smile%2C%20bouncing%20energetic%20pose%2C%20dreamy%20shoujo%20style%2C%20warm%20cream%20background%20with%20sparkles%2C%20clean%20composition%2C%20high%20detail&width=400&height=400&seq=hihi-chibi-01&orientation=squarish',
    desc: '璃舞的守护甜心，活泼开朗，与主人的冷淡形成有趣反差。',
  },
];